import { createAction, props } from '@ngrx/store';
import { DynamicTile } from './tile.service';

export const FetchTiles = createAction('[Tiles] Fetch tiles');
export const FetchTilesFail = createAction('[Tiles] Fetch tiles fail');
export const AddTiles = createAction('[Tiles] Add tiles', props<{ tiles: DynamicTile[] }>());
export const ResetTiles = createAction('[Tiles] Reset');
